import { render, staticRenderFns } from "./ScheduleIntervals.vue?vue&type=template&id=2193c5d7&scoped=true&"
import script from "./ScheduleIntervals.vue?vue&type=script&lang=ts&"
export * from "./ScheduleIntervals.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleIntervals.vue?vue&type=style&index=0&id=2193c5d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2193c5d7",
  null
  
)

export default component.exports